document.querySelectorAll('[data-snc-product]').forEach((root)=>{
  const thumbs=[...root.querySelectorAll('[data-sp-thumb]')];
  const hero=root.querySelector('[data-sp-main] img');
  const frame=root.querySelector('[data-sp-frame]');
  thumbs.forEach((button,index)=>button.addEventListener('click',()=>{
    if(!hero)return;
    hero.src=button.dataset.src;
    hero.alt=button.dataset.alt||'';
    hero.removeAttribute('srcset');
    hero.removeAttribute('sizes');
    thumbs.forEach((thumb)=>{thumb.classList.toggle('is-active',thumb===button);thumb.setAttribute('aria-pressed',String(thumb===button));});
    if(frame)frame.textContent=`${String(index+1).padStart(2,'0')} / ${String(thumbs.length).padStart(2,'0')}`;
  }));
  root.querySelectorAll('[data-sp-variant]').forEach((radio)=>radio.addEventListener('change',()=>{
    const price=root.querySelector('[data-sp-price]');
    if(price)price.textContent=radio.dataset.price;
    const url=new URL(window.location.href);
    url.searchParams.set('variant',radio.value);
    window.history.replaceState({},'',url);
  }));
});
